export default __webpack_public_path__ + "static/media/mdlogo.084b194f.svg";